import store from "@/redux/store";
import React, { useState } from "react";
import { useTranslation, withTranslation, Trans } from "react-i18next";


class BaseController extends React.Component {
    constructor(props) {
        super(props);
        console.info("did mount");
    }
    
    componentDidMount() {
        const { t, i18n, ready } = useTranslation();
        console.info("did mount", t);
    }
}

export default BaseController;